"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentAdapterAdyen = void 0;

var adyen_web_1 = __importDefault(require("@adyen/adyen-web"));

var js_base64_1 = require("js-base64");

var __1 = require("..");

var Configs_1 = require("../Configs");

var interface_adapter_1 = require("../Interfaces/interface.adapter");

var AdyenPaymentMethodMapping;

(function (AdyenPaymentMethodMapping) {
  AdyenPaymentMethodMapping["creditCard"] = "scheme";
  AdyenPaymentMethodMapping["paypal"] = "paypal";
})(AdyenPaymentMethodMapping || (AdyenPaymentMethodMapping = {}));

var AdyenComponentNameMapping;

(function (AdyenComponentNameMapping) {
  AdyenComponentNameMapping["creditCard"] = "card";
  AdyenComponentNameMapping["paypal"] = "paypal";
})(AdyenComponentNameMapping || (AdyenComponentNameMapping = {}));

var PaymentAdapterAdyen =
/** @class */
function (_super) {
  __extends(PaymentAdapterAdyen, _super);

  function PaymentAdapterAdyen(env, vendorSessionInfo, billingContactInfo) {
    var _this = _super.call(this) || this;

    _this.vendorName = interface_adapter_1.PaymentVendors.adyen;
    _this.env = env;
    _this.vendorSessionInfo = vendorSessionInfo;
    _this.billingContactInfo = billingContactInfo;

    if (typeof adyen === 'undefined') {
      throw new __1.PaymentClientError('Cannot find vendor module, please make sure to load it', __1.PaymentErrorShortCodes.missing_vendor_library, {
        cause: {
          message: 'adyen vendor module not loaded'
        }
      });
    }

    return _this;
  }

  PaymentAdapterAdyen.prototype.encryptCreditCardData = function (creditCard) {
    return __awaiter(this, void 0, void 0, function () {
      var adyenSession, cseInstance, name_1, cardDetails, encryptedCard, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this.getDecodedVendorSessionPayload()];

          case 1:
            adyenSession = _a.sent();
            cseInstance = adyen.createEncryption(adyenSession.clientEncryptionKey, {
              enableValidations: false
            });
            name_1 = (creditCard.nameOnCard || "".concat(this.billingContactInfo.name.first, " ").concat(this.billingContactInfo.name.last)).trim();
            cardDetails = {
              number: creditCard.number,
              cvc: creditCard.securityCode,
              expiryMonth: creditCard.expiration.month,
              expiryYear: creditCard.expiration.year,
              holderName: name_1,
              generationtime: this.vendorSessionInfo.timestamp
            };
            encryptedCard = cseInstance.encrypt(cardDetails);

            if (!encryptedCard) {
              throw new __1.PaymentClientError('Invalid credit card number', __1.PaymentErrorShortCodes.invalid_card_number_encryption_error);
            }

            return [2
            /*return*/
            , encryptedCard];

          case 2:
            e_1 = _a.sent();
            throw new __1.PaymentClientError('Validation Error: ' + e_1.message, __1.PaymentErrorShortCodes.invalid_card_number_encryption_error, {
              vendorName: this.vendorName,
              cause: {
                message: e_1.message,
                details: JSON.stringify(e_1)
              }
            });

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentAdapterAdyen.prototype.encryptACHData = function (achInfo) {
    return __awaiter(this, void 0, void 0, function () {
      var adyenSession, cseInstance, name_2, achDetails, encryptedACH, e_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this.getDecodedVendorSessionPayload()];

          case 1:
            adyenSession = _a.sent();
            cseInstance = adyen.createEncryption(adyenSession.clientEncryptionKey, {});
            name_2 = (this.billingContactInfo.name.first + ' ' + this.billingContactInfo.name.last).trim();
            achDetails = {
              bankAccountNumber: achInfo.bankAccountNumber,
              bankLocationId: achInfo.bankRoutingNumber,
              holderName: name_2,
              generationtime: this.vendorSessionInfo.timestamp
            };
            encryptedACH = cseInstance.encrypt(achDetails);

            if (!encryptedACH) {
              throw new __1.PaymentClientError('Failed to encrypt ACH data', __1.PaymentErrorShortCodes.invalid_card_number_encryption_error);
            }

            return [2
            /*return*/
            , encryptedACH];

          case 2:
            e_2 = _a.sent();
            throw new __1.PaymentClientError('Validation Error: ' + e_2.message, __1.PaymentErrorShortCodes.invalid_card_number_encryption_error, {
              vendorName: this.vendorName,
              cause: {
                message: e_2.message,
                details: JSON.stringify(e_2)
              }
            });

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentAdapterAdyen.prototype.initializeWebDropIn = function (divId, paymentMethods, paymentCommunicator, // invoked when component button is clicked to initiate the first step of the charge (tokenization intent)
  onStatus, // get status from final stage
  _onError // get any errors back in this callback
  ) {
    var _a, _b, _c, _d;

    return __awaiter(this, void 0, void 0, function () {
      var adyenPaymentMethodsToDisplay, _i, paymentMethods_1, paymentMethod, adyenSession, adyenDropInEnv, onePaymentMethodIsSupported, configuration, adyenWebDropInConfig, paypalConfig, typedPaypalConfig, decodedMetadata, decodedMetadataString, typedPaypalConfig, checkout, e_3;

      var _this = this;

      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            adyenPaymentMethodsToDisplay = [];

            for (_i = 0, paymentMethods_1 = paymentMethods; _i < paymentMethods_1.length; _i++) {
              paymentMethod = paymentMethods_1[_i];

              switch (paymentMethod) {
                case __1.PaymentMethod.webDropInCreditCard:
                  adyenPaymentMethodsToDisplay.push(AdyenPaymentMethodMapping.creditCard);
                  break;

                case __1.PaymentMethod.webDropInPaypal:
                  adyenPaymentMethodsToDisplay.push(AdyenPaymentMethodMapping.paypal);
                  break;
              }
            }

            if (!adyenPaymentMethodsToDisplay) {
              throw new __1.PaymentClientError('Payment Method is not supported', __1.PaymentErrorShortCodes.unsupported_payment_method);
            }

            _e.label = 1;

          case 1:
            _e.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.getDecodedVendorSessionPayload()];

          case 2:
            adyenSession = _e.sent();
            adyenDropInEnv = Configs_1.Config.isProdEnv(this.env) ? 'live' : 'test';
            onePaymentMethodIsSupported = (_b = (_a = adyenSession.paymentMethodsResponse) === null || _a === void 0 ? void 0 : _a.paymentMethods) === null || _b === void 0 ? void 0 : _b.some(function (method) {
              return adyenPaymentMethodsToDisplay.includes(method.type);
            });

            if (!onePaymentMethodIsSupported) {
              throw new __1.PaymentClientError('Payment Method is not supported', __1.PaymentErrorShortCodes.unsupported_payment_method);
            }

            configuration = {
              paymentMethodsResponse: adyenSession.paymentMethodsResponse,
              allowPaymentMethods: adyenPaymentMethodsToDisplay,
              environment: adyenDropInEnv,
              clientKey: adyenSession.clientKey,
              amount: {
                currency: 'USD',
                value: 0
              },
              onSubmit: function onSubmit(state, dropIn) {
                return __awaiter(_this, void 0, void 0, function () {
                  var paymentMethodType, responseBody, e_4, response;

                  var _a, _b, _c;

                  return __generator(this, function (_d) {
                    switch (_d.label) {
                      case 0:
                        paymentMethodType = this.getDropInPaymentMethod((_b = (_a = state.data) === null || _a === void 0 ? void 0 : _a.paymentMethod) === null || _b === void 0 ? void 0 : _b.type);
                        _d.label = 1;

                      case 1:
                        _d.trys.push([1, 3,, 4]);

                        return [4
                        /*yield*/
                        , paymentCommunicator.initiateWebDropInOrComponentChargeEvent(paymentMethodType, (_c = state.data) === null || _c === void 0 ? void 0 : _c.paymentMethod)];

                      case 2:
                        responseBody = _d.sent();
                        return [3
                        /*break*/
                        , 4];

                      case 3:
                        e_4 = _d.sent();

                        _onError(e_4);

                        dropIn.setStatus('error');
                        return [2
                        /*return*/
                        ];

                      case 4:
                        if (responseBody.action) {
                          // Drop-in handles the action object
                          dropIn.handleAction(responseBody.action);
                        } else {
                          response = {
                            billingToken: this.vendorSessionInfo.billingToken,
                            authId: responseBody.authId
                          };
                          onStatus(response); // Sets your prefered status of the drop-in when payment is processed. In this example, display success.

                          dropIn.setStatus('success', {
                            message: 'Payment was successful'
                          });
                        }

                        return [2
                        /*return*/
                        ];
                    }
                  });
                });
              },
              onError: function onError(error, dropIn) {
                //TODO: Send error log
                // Sets your prefered status of the drop-in when an error occurs. In this example, display error.
                dropIn.setStatus('error');

                _onError(error);
              },
              onAdditionalDetails: function onAdditionalDetails(state, dropIn) {
                return __awaiter(_this, void 0, void 0, function () {
                  var paymentMethodType, responseBody, response;

                  var _a, _b;

                  return __generator(this, function (_c) {
                    switch (_c.label) {
                      case 0:
                        paymentMethodType = this.getDropInPaymentMethod((_b = (_a = state.data) === null || _a === void 0 ? void 0 : _a.paymentMethod) === null || _b === void 0 ? void 0 : _b.type);
                        return [4
                        /*yield*/
                        , paymentCommunicator.processWebDropInOrComponentChargeEvent(paymentMethodType, state.data)];

                      case 1:
                        responseBody = _c.sent();

                        if (responseBody.action) {
                          // Drop-in handles the action object
                          dropIn.handleAction(responseBody.action);
                        } else {
                          response = {
                            billingToken: this.vendorSessionInfo.billingToken,
                            authId: responseBody.authId
                          };
                          onStatus(response); // Sets your prefered status of the drop-in when payment is processed. In this example, display success.

                          dropIn.setStatus('success', {
                            message: 'Payment was successful'
                          });
                        }

                        return [2
                        /*return*/
                        ];
                    }
                  });
                });
              }
            };
            adyenWebDropInConfig = {
              commit: false
            };
            paypalConfig = (_d = (_c = adyenSession.paymentMethodsResponse) === null || _c === void 0 ? void 0 : _c.paymentMethods) === null || _d === void 0 ? void 0 : _d.find(function (method) {
              return method.type === AdyenComponentNameMapping.paypal;
            });

            if (paypalConfig) {
              typedPaypalConfig = paypalConfig.configuration;
              adyenWebDropInConfig.configuration = {
                intent: 'capture',
                merchantId: typedPaypalConfig === null || typedPaypalConfig === void 0 ? void 0 : typedPaypalConfig.merchantId
              };
            } // For full-amount auth, Adyen requires extra configurations to interact with PayPal


            if (this.vendorSessionInfo.metadata) {
              decodedMetadata = undefined;

              try {
                decodedMetadataString = js_base64_1.Base64.decode(this.vendorSessionInfo.metadata);
                decodedMetadata = JSON.parse(decodedMetadataString);
              } catch (e) {// Unable to decrypt metadata
              }

              if ((decodedMetadata === null || decodedMetadata === void 0 ? void 0 : decodedMetadata.amount) > 0) {
                if (paypalConfig) {
                  typedPaypalConfig = paypalConfig.configuration; // Adyen docs on removing PayPal Credit: https://docs.adyen.com/payment-methods/paypal/web-component#paypal-credit

                  adyenWebDropInConfig.blockPayPalCreditButton = true; // PayPal configuration should be set to "authorize"

                  adyenWebDropInConfig.configuration = {
                    intent: 'authorize',
                    merchantId: typedPaypalConfig === null || typedPaypalConfig === void 0 ? void 0 : typedPaypalConfig.merchantId
                  };
                }
              }
            }

            checkout = new adyen_web_1["default"](configuration);
            checkout.create('dropin', adyenWebDropInConfig).mount("#".concat(divId));
            return [3
            /*break*/
            , 4];

          case 3:
            e_3 = _e.sent();
            throw new __1.PaymentClientError('Error creating web drop-in: ' + e_3.message, __1.PaymentErrorShortCodes.server_session_error, {
              vendorName: this.vendorName,
              cause: {
                message: e_3.message,
                details: JSON.stringify(e_3)
              }
            });

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentAdapterAdyen.prototype.initializeWebComponent = function (divId, paymentMethod, paymentCommunicator, // invoked when component button is clicked to initiate the first step of the charge (tokenization intent)
  onStatus, // get status from final stage
  _onError2 // get any errors back in this callback
  ) {
    var _a, _b, _c, _d;

    return __awaiter(this, void 0, void 0, function () {
      var adyenPaymentMethodToDisplay, adyenComponentName, adyenSession, adyenComponentEnv, isPaymentMethodSupported, configuration, adyenWebComponentConfig, paypalConfig, typedPaypalConfig, decodedMetadata, decodedMetadataString, typedPaypalConfig, checkout, e_5;

      var _this = this;

      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            switch (paymentMethod) {
              case __1.PaymentMethod.webComponentCreditCard:
                adyenPaymentMethodToDisplay = AdyenPaymentMethodMapping.creditCard;
                adyenComponentName = AdyenComponentNameMapping.creditCard;
                break;

              case __1.PaymentMethod.webComponentPaypal:
                adyenPaymentMethodToDisplay = AdyenPaymentMethodMapping.paypal;
                adyenComponentName = AdyenComponentNameMapping.paypal;
                break;

              default:
                throw new __1.PaymentClientError('Payment Method is not supported', __1.PaymentErrorShortCodes.unsupported_payment_method);
            }

            _e.label = 1;

          case 1:
            _e.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.getDecodedVendorSessionPayload()];

          case 2:
            adyenSession = _e.sent();
            adyenComponentEnv = Configs_1.Config.isProdEnv(this.env) ? 'live' : 'test';
            isPaymentMethodSupported = (_b = (_a = adyenSession.paymentMethodsResponse) === null || _a === void 0 ? void 0 : _a.paymentMethods) === null || _b === void 0 ? void 0 : _b.some(function (method) {
              return adyenPaymentMethodToDisplay == method.type;
            });

            if (!isPaymentMethodSupported) {
              throw new __1.PaymentClientError('Payment Method is not supported', __1.PaymentErrorShortCodes.unsupported_payment_method);
            }

            configuration = {
              paymentMethodsResponse: adyenSession.paymentMethodsResponse,
              allowPaymentMethods: [adyenPaymentMethodToDisplay],
              environment: adyenComponentEnv,
              clientKey: adyenSession.clientKey,
              showPayButton: true,
              onSubmit: function onSubmit(state, component) {
                return __awaiter(_this, void 0, void 0, function () {
                  var responseBody, e_6, response;

                  var _a;

                  return __generator(this, function (_b) {
                    switch (_b.label) {
                      case 0:
                        _b.trys.push([0, 2,, 3]);

                        return [4
                        /*yield*/
                        , paymentCommunicator.initiateWebDropInOrComponentChargeEvent(paymentMethod, (_a = state.data) === null || _a === void 0 ? void 0 : _a.paymentMethod)];

                      case 1:
                        responseBody = _b.sent();
                        return [3
                        /*break*/
                        , 3];

                      case 2:
                        e_6 = _b.sent();

                        _onError2(e_6);

                        component.setStatus('error');
                        return [2
                        /*return*/
                        ];

                      case 3:
                        if (responseBody.action) {
                          // Component handles the action object
                          component.handleAction(responseBody.action);
                        } else {
                          response = {
                            billingToken: this.vendorSessionInfo.billingToken,
                            authId: responseBody.authId
                          };
                          onStatus(response); // Sets your prefered status of the component when payment is processed. In this example, display success.

                          component.setStatus('success', {
                            message: 'Payment was successful'
                          });
                        }

                        return [2
                        /*return*/
                        ];
                    }
                  });
                });
              },
              onError: function onError(error, component) {
                //TODO: Send error log
                // Sets your prefered status of the component when an error occurs. In this example, display error.
                component.setStatus('error');

                _onError2(error);
              },
              onAdditionalDetails: function onAdditionalDetails(state, component) {
                return __awaiter(_this, void 0, void 0, function () {
                  var responseBody, response;
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        return [4
                        /*yield*/
                        , paymentCommunicator.processWebDropInOrComponentChargeEvent(paymentMethod, state.data)];

                      case 1:
                        responseBody = _a.sent();

                        if (responseBody.action) {
                          // Component handles the action object
                          component.handleAction(responseBody.action);
                        } else {
                          response = {
                            billingToken: this.vendorSessionInfo.billingToken,
                            authId: responseBody.authId
                          };
                          onStatus(response); // Sets your prefered status of the component when payment is processed. In this example, display success.

                          component.setStatus('success', {
                            message: 'Payment was successful'
                          });
                        }

                        return [2
                        /*return*/
                        ];
                    }
                  });
                });
              }
            };
            adyenWebComponentConfig = {
              commit: false
            };
            paypalConfig = (_d = (_c = adyenSession.paymentMethodsResponse) === null || _c === void 0 ? void 0 : _c.paymentMethods) === null || _d === void 0 ? void 0 : _d.find(function (method) {
              return method.type === AdyenComponentNameMapping.paypal;
            });

            if (paypalConfig) {
              typedPaypalConfig = paypalConfig.configuration;
              adyenWebComponentConfig.configuration = {
                intent: 'capture',
                merchantId: typedPaypalConfig === null || typedPaypalConfig === void 0 ? void 0 : typedPaypalConfig.merchantId
              };
            } // For full-amount auth, Adyen requires extra configurations to interact with PayPal


            if (this.vendorSessionInfo.metadata) {
              decodedMetadata = undefined;

              try {
                decodedMetadataString = js_base64_1.Base64.decode(this.vendorSessionInfo.metadata);
                decodedMetadata = JSON.parse(decodedMetadataString);
              } catch (e) {// Unable to decrypt metadata
              }

              if ((decodedMetadata === null || decodedMetadata === void 0 ? void 0 : decodedMetadata.amount) > 0) {
                if (paypalConfig) {
                  typedPaypalConfig = paypalConfig.configuration; // Adyen docs on removing PayPal Credit: https://docs.adyen.com/payment-methods/paypal/web-component#paypal-credit

                  adyenWebComponentConfig.blockPayPalCreditButton = true; // PayPal configuration should be set to "authorize"

                  adyenWebComponentConfig.configuration = {
                    intent: 'authorize',
                    merchantId: typedPaypalConfig === null || typedPaypalConfig === void 0 ? void 0 : typedPaypalConfig.merchantId
                  };
                }
              }
            }

            checkout = new adyen_web_1["default"](configuration);
            checkout.create(adyenComponentName, adyenWebComponentConfig).mount("#".concat(divId));
            return [3
            /*break*/
            , 4];

          case 3:
            e_5 = _e.sent();
            throw new __1.PaymentClientError('Error creating web component: ' + e_5.message, __1.PaymentErrorShortCodes.server_session_error, {
              vendorName: this.vendorName,
              cause: {
                message: e_5.message,
                details: JSON.stringify(e_5)
              }
            });

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentAdapterAdyen.prototype.getDropInPaymentMethod = function (adyenPaymentMethodType) {
    switch (adyenPaymentMethodType) {
      case AdyenPaymentMethodMapping.creditCard:
        return __1.PaymentMethod.webDropInCreditCard;

      case AdyenPaymentMethodMapping.paypal:
        return __1.PaymentMethod.webDropInPaypal;
    }
  };

  return PaymentAdapterAdyen;
}(interface_adapter_1.PaymentAdapter);

exports.PaymentAdapterAdyen = PaymentAdapterAdyen;